<script>
import ClubRepository from '../../js/repository/ClubRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubRepository.getNumberRangeSettings,
                params: [this.clubId],
                callback: this.callback,
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
